import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-277c23a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xyp-value-renderer" }
const _hoisted_2 = {
  key: 0,
  class: "xyp-no-data"
}
const _hoisted_3 = {
  key: 1,
  class: "xyp-table-scroll"
}
const _hoisted_4 = {
  key: 2,
  class: "xyp-card-list"
}
const _hoisted_5 = { class: "xyp-record-number" }
const _hoisted_6 = {
  key: 3,
  class: "xyp-chip-list"
}
const _hoisted_7 = {
  key: 0,
  class: "xyp-field-grid"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Мэдээллийн бүлэг", -1))
const _hoisted_9 = {
  key: 0,
  class: "xyp-count"
}
const _hoisted_10 = {
  key: 1,
  class: "xyp-no-data"
}
const _hoisted_11 = {
  key: 2,
  class: "xyp-field-card xyp-field-card--wide"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_xyp_value_renderer = _resolveComponent("xyp-value-renderer", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (Array.isArray(_ctx.value))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Мэдээлэл байхгүй."))
            : (_ctx.isFlatObjectArray(_ctx.value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_el_table, {
                    data: _ctx.value,
                    border: "",
                    stripe: "",
                    size: "small",
                    class: "xyp-table"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableColumns(_ctx.value), (column) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          key: column,
                          prop: column,
                          label: _ctx.formatKey(column),
                          "min-width": "160",
                          "show-overflow-tooltip": ""
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("span", {
                              class: _normalizeClass(_ctx.valueClass(scope.row[column]))
                            }, _toDisplayString(_ctx.formatValue(scope.row[column])), 3)
                          ]),
                          _: 2
                        }, 1032, ["prop", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]))
              : (_ctx.value.every(_ctx.isObject))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: index,
                        class: "xyp-record-card"
                      }, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(index + 1), 1),
                        _createVNode(_component_xyp_value_renderer, { value: item }, null, 8, ["value"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(_ctx.formatValue(item)), 1))
                    }), 128))
                  ]))
        ], 64))
      : (_ctx.isObject(_ctx.value))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.simpleEntries(_ctx.value).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.simpleEntries(_ctx.value), ([key, item], index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: _normalizeClass(["xyp-field-card", { 'xyp-field-card--wide': _ctx.isLongValue(item, index) }])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatKey(key)), 1),
                      _createElementVNode("strong", {
                        class: _normalizeClass(_ctx.valueClass(item))
                      }, _toDisplayString(_ctx.formatValue(item)), 3)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.complexEntries(_ctx.value), ([key, item]) => {
              return (_openBlock(), _createElementBlock("section", {
                key: key,
                class: "xyp-nested-section"
              }, [
                _createElementVNode("header", null, [
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createElementVNode("h3", null, _toDisplayString(_ctx.sectionTitle(key)), 1)
                  ]),
                  (Array.isArray(item))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.length) + " мөр ", 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_xyp_value_renderer, { value: item }, null, 8, ["value"])
              ]))
            }), 128)),
            (!_ctx.simpleEntries(_ctx.value).length && !_ctx.complexEntries(_ctx.value).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Мэдээлэл байхгүй. "))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("strong", {
              class: _normalizeClass(_ctx.valueClass(_ctx.value))
            }, _toDisplayString(_ctx.formatValue(_ctx.value)), 3)
          ]))
  ]))
}